/**
 * Huella SHA-256 de un archivo descargado, en hexadecimal. Permite comprobar en el navegador que el
 * PDF recibido es exactamente el emitido (HU-A05 CA-2), además de la verificación del servidor.
 * Devuelve `null` si el contexto no ofrece `crypto.subtle` (p. ej. HTTP sin TLS).
 */
export async function sha256Hex(blob: Blob): Promise<string | null> {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) return null;
  const digest = await subtle.digest('SHA-256', await leerBytes(blob));
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
}

/** `Blob.arrayBuffer` con respaldo en `FileReader` (navegadores antiguos y jsdom no lo implementan). */
export function leerBytes(blob: Blob): Promise<ArrayBuffer> {
  if (typeof blob.arrayBuffer === 'function') return blob.arrayBuffer();
  return new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.onload = () => resolve(lector.result as ArrayBuffer);
    lector.onerror = () => reject(lector.error ?? new Error('No fue posible leer el archivo.'));
    lector.readAsArrayBuffer(blob);
  });
}
